'use client';

import { Toaster } from 'react-hot-toast';

export function ToasterClient() {
  return (
    <Toaster
      position="top-right"
      containerStyle={{
        zIndex: 99999,
      }}
      toastOptions={{
        duration: 5000,
        style: {
          background: 'var(--bg2)',
          color: 'var(--fg0)',
          border: '1px solid var(--separator1)',
          borderRadius: '12px',
          padding: '12px 16px',
          fontSize: '14px',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.4)',
          backdropFilter: 'blur(12px)',
          zIndex: 99999,
        },
        success: {
          iconTheme: {
            primary: 'var(--fgAccent1)',
            secondary: 'var(--bg0)',
          },
        },
        error: {
          style: {
            background: 'var(--bg2)',
            border: '1px solid rgba(239, 68, 68, 0.3)',
          },
          iconTheme: {
            primary: '#ef4444',
            secondary: 'var(--bg0)',
          },
        },
      }}
    />
  );
}
